'use strict';

/**
 * @class NotesDocumentList
 * @extends DocumentList
 * a document list for notes retrieved for items, listings, etc.
 */
const DocumentList = require('bunsen/models/DocumentList');
const NotesDocumentList = module.exports = DocumentList.extend();
const _ = require('underscore');
const endpoints = require('dibs-endpoints');
const Note = require('bunsen/models/Note');
const User = require('bunsen/models/identity/User');
const Party = require('bunsen/models/Party');
const Clump = require('bunsen/libraries/clump');

Object.assign(NotesDocumentList, {
    /**
     * Create a new Note instance
     * @param {object} [options]
     * @param {string} [options.role=INTERNAL]
     * @param {string} [options.type=ADMIN]
     * @param {string} [options.level=INFO]
     * @param {string|number} [options.creatorId] Defaults to current user id
     * @param {string} [options.content] Defaults to empty string
     * @param {anchors} [options.anchors] Defaults to empty array
     * @returns {Note}
     */
    newNote: function (options) {
        if (!options.user instanceof User) {
            throw "options.user must be instance of bunsen/models/identity/User";
        }
        const defaultUser = options.user;
        options = _.defaults(options || {}, {
            role: Party.ROLE_INTERNAL,
            type: Note.TYPE_ADMIN,
            level: 'INFO',
            creatorId: defaultUser.id,
            creatorProfile: defaultUser.get('profile'),
            content: '',
            service: endpoints.latest.identity
        });
        return new Note({
            type: options.type,
            content: options.content,
            level: options.level,
            anchors: options.anchors,
            createdBy: {
                role: options.role,
                id: options.creatorId,
                profile: options.creatorProfile ? options.creatorProfile.toJSON() : {}
            }
        }, {
            service: options.service
        });
    }
});

Object.assign(NotesDocumentList.prototype, {
    model(attrs) {
        return new Note(attrs, {service: this.service});
    },

    url : function () {
        return endpoints.notes(this.service);
    },

    initialize(attrs = { metadata: {}, documents: [] }, options = {}) {
        this.service = options.service || endpoints.latest.inventory;
        return NotesDocumentList.__super__.initialize.call(this, options);
    },

    /**
     * Fetch all ITEM_IMAGING and DEALER_IMAGING notes
     * based on item id
     * @param itemId
     * @param options
     * @returns promise
     */
    fetchItemNotes(itemId, sellerId, options) {
        options = options || {};
        options.clump = options.clump || new Clump();
        this._fetchImagingNotes(itemId, options);
        this._fetchDealerNotes(sellerId, options);
        return options.clump;
    },

    _fetchDealerNotes(dealerId, options) {
        options = options || {};
        const fetchOptions = {
            data: Object.assign({
                anchorSourceType: 'SELLER',
                anchorIds: dealerId,
                noteTypes: Note.TYPE_DEALER_IMAGING,
                fields: 'PARTY_PROFILE'
            }, options && options.data),
            remove: false
        };

        return this.fetch(Object.assign({}, options, fetchOptions));
    },

    _fetchImagingNotes(itemId, options) {
        options = options || {};
        const fetchOptions = {
            data: Object.assign({
                anchorSourceType: 'ITEM',
                anchorIds: itemId,
                noteTypes: Note.TYPE_ITEM_IMAGING,
                fields: 'PARTY_PROFILE'
            }, options && options.data),
            remove: false
        };

        return this.fetch(Object.assign({}, options, fetchOptions));
    },

    fetchRejectionNotes(itemId, options) {
        options = options || {};
        const fetchOptions = {
            data: Object.assign({
                anchorSourceType: 'ITEM',
                anchorIds: itemId,
                noteTypes: Note.TYPE_EXPERT_REVIEW_REJECTION,
                fields: 'PARTY_PROFILE'
            }, options && options.data),
            remove: false
        };

        return this.fetch(Object.assign({}, options, fetchOptions));
    },

    /**
     * Find a note by id
     * @param noteId
     * @returns Note
     */
    findById(noteId) {
        return this.findWhere({id: noteId});
    },

    /**
     * Helper function for creating new notes on the document list.
     * Calls existing static method for not creation.
     * @param passedOptions
     * @returns Note
     */
    newNote: function (passedOptions) {
        passedOptions.service = passedOptions.service || this.service;
        return NotesDocumentList.newNote(passedOptions);
    },

    /**
     * Create a new note, and add it to the document list on this model.
     * @param noteOptions
     * @param syncOptions
     * @returns deferred from saving note to server
     */
    addNewNote: function (noteOptions, syncOptions) {
        const note = this.newNote(noteOptions);
        this.add(note);
        return note.save(null, syncOptions);
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/NotesDocumentList.es.js